/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsReferralListItem
 */
export interface IdentityMelcoModelsReferralListItem {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsReferralListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsReferralListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsReferralListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsReferralListItem
     */
    type?: string | null;
}

export function IdentityMelcoModelsReferralListItemFromJSON(json: any): IdentityMelcoModelsReferralListItem {
    return IdentityMelcoModelsReferralListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsReferralListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsReferralListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function IdentityMelcoModelsReferralListItemToJSON(value?: IdentityMelcoModelsReferralListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'description': value.description,
        'type': value.type,
    };
}


